<template>
  <table class="ui striped selectable table">
    <thead>
      <tr>
        <th></th>
        <th>Name</th>
        <th>Modified at</th>
      </tr>
    </thead>
    <tbody>
      <tr v-if="!classList || classList.length == 0">
        <td></td>
        <td colspan="4">
          No classes found. Click the button below to add a new one.
        </td>
      </tr>
      <class-table-row
        v-for="item in classList"
        v-bind:item="item"
        v-bind:key="item.Id"
        v-bind:actions="actions"
        v-on:action="rowAction"
      />
    </tbody>
  </table>
</template>

<script>
import ClassTableRow from '@/components/classes/ClassTableRow';

export default {
  name: 'ClassTable',
  computed: {
    classList() {
      return this.classes || null;
    },
  },
  components: { ClassTableRow },
  props: ['classes', 'actions'],
  methods: {
    rowAction(action) {
      this.$emit('rowAction', action);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/classes/ClassTable.vue